import TemplateView from '../../../../TemplateView'

export default class OnlyActiveSwitch extends TemplateView {
    constructor({
        onlyActiveSelectedText = '',
        allStatusesSelectedText = '',
        onChanged = onlyActive => {}
    }) {
        super()

        this.params = {
            onlyActiveSelectedText,
            allStatusesSelectedText
        }

        this.callbacks = {
            onChanged
        }

        this.state = {
            onlyActive: false
        }

        this.onStatePropertyChanged('onlyActive', onlyActive => {
            this.$el.text(!onlyActive ? this.params.onlyActiveSelectedText : this.params.allStatusesSelectedText)
        })
    }

    templateHtml() {
        return "<div class='onlyActiveSwitcher'></div>"
    }

    afterRender() {
        this.$el.click(() => {
            const newOnlyActiveValue = !this.state.onlyActive
            this.setState({
                onlyActive: newOnlyActiveValue
            })
            this.callbacks.onChanged(newOnlyActiveValue)
        })

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/OnlyActiveSwitch.js